import React from "react";
import { Link } from "react-router-dom";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function Home() {
  return (
    <>
      <HeaderWithSearch />
      <main
        className="home-scroll-container"
      >
        {/* Hero Section */}
        <section className="home-hero">
          <div className="home-hero-copy">
            <h1>Welcome to VMCREATION.com</h1>
            <p>
              Hi! I'm Vivaan Muchetty, an eighth grader passionate about coding, music, and cooking. Scroll down to explore my favorite projects, piano covers, and recipes!
            </p>
          </div>
          <div className="home-hero-image">
            <ImageWithFallback src="/intro-main.jpg" alt="Vivaan" style={{ width: 420, height: 420, borderRadius: 24, boxShadow: "0 4px 32px rgba(0,0,0,0.10)", objectFit: "cover" }} />
          </div>
        </section>

        {/* High Quality Video Games Section */}
        <section className="home-section surface">
          <h2>High Quality Video Games</h2>
          <div className="home-grid">
            <Link to="/high-quality-games" className="home-card">
                <div
                  className="home-card-image-wrap"
                  style={{ background: "linear-gradient(135deg, #0f1226 0%, #241a4d 100%)", fontSize: "3.6rem" }}
                >
                  <span role="img" aria-label="Block Blast">🧩</span>
                </div>
                <h3>Block Blast</h3>
                <p>A C++ engine compiled to WebAssembly — ultra-fast, 3D-style blocks, and fully playable offline.</p>
            </Link>
            <Link to="/high-quality-games" className="home-card">
                <div
                  className="home-card-image-wrap"
                  style={{ background: "linear-gradient(135deg, #1a0b2e 0%, #4a1259 100%)", fontSize: "3.6rem" }}
                >
                  <span role="img" aria-label="Bubble Blast">🫧</span>
                </div>
                <h3>Bubble Blast</h3>
                <p>An original bubble shooter, built from scratch in the same glossy style as Block Blast.</p>
            </Link>
            <Link to="/high-quality-games" className="home-card">
                <div
                  className="home-card-image-wrap"
                  style={{ background: "linear-gradient(135deg, #2b0a20 0%, #a3197a 100%)", fontSize: "3.6rem" }}
                >
                  <span role="img" aria-label="Bubble Burst">💥</span>
                </div>
                <h3>Bubble Burst</h3>
                <p>Click a cluster of matching bubbles and watch a crowd of them pop at once.</p>
            </Link>
          </div>
        </section>

        {/* Coding Projects Section */}
        <section className="home-section soft">
          <h2>Coding Projects</h2>
          <div className="home-grid">
            <Link to="/games" className="home-card">
                <div className="home-card-image-wrap">
                  <ImageWithFallback src="/car_game.gif" alt="Games" style={{ width: "100%", height: "100%", objectFit: "contain", borderRadius: 12 }} />
                </div>
                <h3>Games</h3>
                <p>Fun coding games and interactive projects.</p>
            </Link>
            <Link to="/math" className="home-card">
                <div className="home-card-image-wrap">
                  <ImageWithFallback src="/LCM_2.png" alt="Math" style={{ width: "100%", height: "100%", objectFit: "contain", borderRadius: 12 }} />
                </div>
                <h3>Math</h3>
                <p>Math games and challenges to test your skills.</p>
            </Link>
            <Link to="/drawing" className="home-card">
                <div className="home-card-image-wrap">
                  <ImageWithFallback src="/rainbow_turtle.gif" alt="Drawing" style={{ width: "100%", height: "100%", objectFit: "contain", borderRadius: 12 }} />
                </div>
                <h3>Drawing</h3>
                <p>Creative coding art and turtle graphics.</p>
            </Link>
            <Link to="/web-development" className="home-card">
                <div className="home-card-image-wrap">
                  <ImageWithFallback src="/profile.png" alt="Vivaan's Web Development" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 12 }} />
                </div>
                <h3>Vivaan's Web Development</h3>
                <p>Web projects including the business card page.</p>
            </Link>
          </div>
        </section>

        {/* Cooking Section */}
        <section className="home-section surface">
          <h2>Cooking</h2>
          <div className="home-grid">
            <Link to="/drinks" className="home-card">
                <ImageWithFallback src="/mint-mojito.jpg" alt="Drinks" style={{ width: 120, height: 120, objectFit: "cover", marginBottom: 16, borderRadius: 12 }} />
                <h3>Drinks</h3>
                <p>Refreshing drinks and smoothies.</p>
            </Link>
            <Link to="/meals" className="home-card">
                <ImageWithFallback src="/potato-curry.jpg" alt="Meals" style={{ width: 120, height: 120, objectFit: "cover", marginBottom: 16, borderRadius: 12 }} />
                <h3>Meals</h3>
                <p>Delicious meal recipes to try at home.</p>
            </Link>
            <Link to="/snacks" className="home-card">
                <ImageWithFallback src="/charred-corn.jpg" alt="Snacks" style={{ width: 120, height: 120, objectFit: "cover", marginBottom: 16, borderRadius: 12 }} />
                <h3>Snacks</h3>
                <p>Tasty snacks and quick bites.</p>
            </Link>
          </div>
        </section>

        {/* Piano Cover Songs Section */}
        <section className="home-section soft">
          <h2>Piano Cover Songs</h2>
          <div className="home-grid">
            <Link to="/pop" className="home-card">
                <ImageWithFallback src="/Senorita.png" alt="Pop" style={{ width: 120, height: 120, objectFit: "cover", marginBottom: 16, borderRadius: 12 }} />
                <h3>Pop</h3>
                <p>Popular English piano covers.</p>
            </Link>
            <Link to="/hindi_songs" className="home-card">
                <ImageWithFallback src="/Jee_le_zara.png" alt="Hindi Songs" style={{ width: 120, height: 120, objectFit: "cover", marginBottom: 16, borderRadius: 12 }} />
                <h3>Hindi Songs</h3>
                <p>Beautiful Hindi piano covers.</p>
            </Link>
            <Link to="/favorite_songs" className="home-card">
                <ImageWithFallback src="/Shape_of_you.png" alt="Favorite Songs" style={{ width: 120, height: 120, objectFit: "cover", marginBottom: 16, borderRadius: 12 }} />
                <h3>Favorite Songs</h3>
                <p>My all-time favorite piano covers.</p>
            </Link>
          </div>
        </section>
      </main>
    </>
  );
}

export default Home;